import { FC, ReactNode, useMemo } from 'react';

import MuiAutocomplete, {
  AutocompleteProps as MuiAutocompleteProps,
} from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export type Option = {
  id: string;
  name: string;
};

type Props = Omit<
  MuiAutocompleteProps<Option, boolean, false, false>,
  'renderInput'
> & {
  helperText?: ReactNode;
  label?: ReactNode;
  error?: boolean;
};

export type AutocompleteBaseProps = Props;

const getOptionLabel = ({ name }: Option) => name;

const isOptionEqualToValue = (option: Option, value: Option) =>
  option.id === value.id;

const AutocompleteBase: FC<Props> = props => {
  const { label, helperText, error, options, ...rest } = props;

  const sorted = useMemo(
    () =>
      [...options].sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      }),
    [options]
  );

  return (
    <MuiAutocomplete<Option, boolean, false, false>
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      renderInput={params => (
        <TextField
          {...params}
          variant="standard"
          error={error}
          label={label}
          helperText={helperText}
        />
      )}
      options={sorted}
      {...rest}
    />
  );
};

export default AutocompleteBase;
